import { render, staticRenderFns } from "./AdvTable.vue?vue&type=template&id=d2493e6a&scoped=true"
import script from "./AdvTable.vue?vue&type=script&lang=js"
export * from "./AdvTable.vue?vue&type=script&lang=js"
import style0 from "./AdvTable.vue?vue&type=style&index=0&id=d2493e6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2493e6a",
  null
  
)

export default component.exports